module.exports = __webpack_public_path__ + "img/4.921367bb.jpg";